import { ScrollView } from "react-native";
import { Colors, View } from "react-native-ui-lib";
import { CartProvider, CartProviderProps } from "./CartProvider";
import { Header } from "./components/Header/header";
import { Body } from "./components/Body";
import { Totals } from "./components/Totals";
import { Footer } from "./components/Footer/Footer";

export interface CartProps {
  sale: CartProviderProps["sale"];
}

export const Cart = (props: CartProps) => {
  return (
    <CartProvider {...props}>
      <View
        style={{
          flex: 1,
          borderRadius: 8,
        }}
      >
        <ScrollView
          style={{ flex: 1 }}
          nestedScrollEnabled={true}
          contentContainerStyle={{ flexGrow: 1 }}
        >
          <Header />
          <Body />
        </ScrollView>

        <View
          paddingT-10
          style={{
            borderTopWidth: 2,
            borderTopColor: Colors.borderColor,
          }}
        >
          <Totals />
          <Footer />
        </View>
      </View>
    </CartProvider>
  );
};

Cart.Footer = Footer;
Cart.Body = Body;
Cart.Header = Header;
Cart.Totals = Totals;
